import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function BeforeAfter() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-22" data-mp="3ofhx3ds4fjys">
      <div className="mx-auto max-w-6xl px-4" data-id="element-23" data-mp="3sgtmbi73236g">
        <SectionHeading title="The Difference a Clear Structure Makes" data-id="element-24" data-mp="3sfjpewbyv11e" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-25" data-mp="3ep6f4nblra8w">
          <div className="rounded-3xl border border-danger/25 bg-white p-6 sm:p-8" data-id="element-26" data-mp="3jgeppmoo51nn">
            <p className="inline-flex rounded-full bg-danger px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-27" data-mp="3jihs7670cn99">Before</p>
            <h3 className="mt-3 font-display text-2xl font-bold text-ink" data-id="element-28" data-mp="39q3inr9ouccj">Before Third Molar Assessment Blueprint™</h3>
            <ul className="mt-5 space-y-3" data-id="element-29" data-mp="2vsf2uxuh9vec">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-base leading-relaxed text-ink/80" data-id="element-30" data-mp="30ovnhi2gxrmo">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-danger/10 text-danger" data-id="element-31" data-mp="x38xmtv2iecj">
                    <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="t51j85o2tp4i" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 shadow-[0_24px_60px_-30px_rgba(16,42,76,0.8)] sm:p-8" data-id="element-33" data-mp="1246jbgfadqis">
            <p className="inline-flex rounded-full bg-cta px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-34" data-mp="eec3cpzo7lub">After</p>
            <h3 className="mt-3 font-display text-2xl font-bold text-white" data-id="element-35" data-mp="o3lxschzlgll">With Third Molar Assessment Blueprint™</h3>
            <ul className="mt-5 space-y-3" data-id="element-36" data-mp="jcvquutwx5os">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-base leading-relaxed text-white/90" data-id="element-37" data-mp="3rsfg7irgq3yk">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-38" data-mp="3munrexm46xyl">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="1qpy5fscowyqp" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-40" data-mp="20hu4p6qiiuwi">
          <p data-id="element-41" data-mp="24hmibxurjr8q">The goal isn’t to make complex surgical cases artificially simple.</p>
          <p className="font-semibold text-ink" data-id="element-42" data-mp="17t6pnswcx1re">
            It’s to help you approach the available information in a more organized and systematic way.
          </p>
        </div>

        <div className="mt-10" data-id="element-43" data-mp="1gsa8qwvixh5w">
          <CtaButton label="Yes, I Want a Structured Third Molar Assessment System" data-id="element-44" data-mp="1gr0ao7oo88z9" />
        </div>
      </div>
    </section>;
}